import { render, staticRenderFns } from "./FormPickingListItem.vue?vue&type=template&id=8da1d0f0"
import script from "./FormPickingListItem.vue?vue&type=script&lang=js"
export * from "./FormPickingListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormPickingListItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8da1d0f0')) {
      api.createRecord('8da1d0f0', component.options)
    } else {
      api.reload('8da1d0f0', component.options)
    }
    module.hot.accept("./FormPickingListItem.vue?vue&type=template&id=8da1d0f0", function () {
      api.rerender('8da1d0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormPickingListItem.vue"
export default component.exports